import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY

console.log('[supabaseClient] Initializing with URL:', supabaseUrl);
console.log('[supabaseClient] Key exists:', !!supabaseKey);
console.log('[supabaseClient] Key length:', supabaseKey?.length);

if (!supabaseUrl || !supabaseKey) {
  console.error('[supabaseClient] ⚠️  MISSING SUPABASE CREDENTIALS!');
  console.error('[supabaseClient] URL:', supabaseUrl);
  console.error('[supabaseClient] Key:', supabaseKey ? 'EXISTS' : 'MISSING');
  throw new Error('Supabase credentials not configured! Check your .env file.');
}

// Create client with optimized configuration
// detectSessionInUrl disabled by default to avoid slowdowns
// Only the ResetPassword component should use detectSessionInUrl
export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: false, // Disabled globally - causes timeout issues
    storage: window.localStorage,
  },
  global: {
    headers: {
      'X-Client-Info': 'supabase-js-web',
    },
  },
})

console.log('[supabaseClient] detectSessionInUrl: false (optimized for performance)');

console.log('[supabaseClient] ✅ Client created successfully');
